import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class PatentesService {
    _getHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }

    _handleError(error, defaultMessage) {
        if (error.response) {
            throw new Error(error.response.data.message || defaultMessage);
        } else if (error.request) {
            throw new Error('No se pudo conectar con el servidor');
        } else {
            throw new Error(error.message || defaultMessage);
        }
    }

    /**
     * Obtener arriendos vigentes del año + pagos de patentes registrados
     */
    async getPatentesPorAnio(anio, id_company, token) {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/api/patentes/${anio}`,
                { params: { id_company }, headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al obtener patentes');
        }
    }

    /**
     * Crear un pago de patente
     */
    async createPago(pagoData, token) {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/patentes`,
                pagoData,
                { headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al crear pago de patente');
        }
    }

    /**
     * Actualizar un pago de patente
     */
    async updatePago(id, pagoData, token) {
        try {
            const response = await axios.put(
                `${API_BASE_URL}/api/patentes/${id}`,
                pagoData,
                { headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al actualizar pago de patente');
        }
    }

    /**
     * Eliminar un pago de patente
     */
    async deletePago(id, id_company, token) {
        try {
            const response = await axios.delete(
                `${API_BASE_URL}/api/patentes/${id}`,
                { params: { id_company }, headers: this._getHeaders(token) }
            );
            return response.data;
        } catch (error) {
            this._handleError(error, 'Error al eliminar pago de patente');
        }
    }

}

const patentesService = new PatentesService();
export default patentesService;
